import React, { useMemo } from "react"

import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { CustomerOrder } from "pages/admin/Customers/NewThisMonth"
import { useTranslation } from "react-i18next"

interface CustomerOrdersTable {
  customersOrders: CustomerOrder[]
  isAllChecked: boolean
  checkedCustomersOrders: CustomerOrder[]
  toggleAllCustomersOrders: () => void
  toggleActiveCustomerOrders: (customerOrder: CustomerOrder) => void
  togglecheckedCustomerOrdersHandler: (customerOrder: CustomerOrder) => void
  location?: any
}

const CustomerOrdersTable: React.FC<CustomerOrdersTable> = ({
  customersOrders,
  checkedCustomersOrders,
  isAllChecked,
  toggleActiveCustomerOrders,
  toggleAllCustomersOrders,
  togglecheckedCustomerOrdersHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllCustomersOrders}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return (
            <input
              onClick={() =>
                togglecheckedCustomerOrdersHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedCustomersOrders.find(
                  c => c.id === cellProps.row.original.id
                )
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("customers_customerName"),
        accessor: "customerName",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return (
            <div className="d-flex flex-column align-items-statrt">
              <p className="mb-0">{cellProps.row.original.customerName}</p>
              <p className="mb-0">{cellProps.row.original.id}</p>
            </div>
          )
        },
      },
      {
        Header: t("customers_purchaseType"),
        accessor: "purchaseType",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return <>{cellProps.row.original.purchaseType}</>
        },
      },
      {
        Header: t("customers_areas"),
        accessor: "area",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return <>{cellProps.row.original.area}</>
        },
      },
      {
        Header: t("customers_averageOrderValue"),
        accessor: "averageOrderValue",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return <>{cellProps.row.original.averageOrderValue}</>
        },
      },
      {
        Header: t("customers_received"),
        accessor: "received",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return <>{cellProps.row.original.received}</>
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: CustomerOrder } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.status === "Active"}
                onClick={() =>
                  toggleActiveCustomerOrders(cellProps.row.original)
                }
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.status}
              </label>
            </div>
          )
        },
      },
    ],
    [customersOrders, t, customersOrders]
  )

  return (
    <TableContainer
      columns={columns}
      data={customersOrders}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

CustomerOrdersTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CustomerOrdersTable))
